import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import CloseIcon from '@material-ui/icons/Close';
import GridHidden from '../GridHidden';

const useStyles = makeStyles(theme => ({
  picker: {
    marginTop: theme.spacing(0),
  },
}));

const TimeFilter = props => {
  const {
    timeFilterFrom,
    timeFilterTo,
    onReset,
    onChangeFrom,
    onChangeTo,
  } = props;
  const classes = useStyles();
  const hasValue = timeFilterFrom || timeFilterTo;
  console.log(timeFilterTo, timeFilterFrom)
  return (
    <Box mb={2}>
      <Grid container spacing={2}>
        <GridHidden item sm={2} only="xs" />
        <Grid item xs={12} sm={8}>
          <Typography variant="body1" color="textSecondary">
            Inhalte zeitlich filtern
          </Typography>
        </Grid>
        <GridHidden item sm={2} only="xs" />
      </Grid>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Grid container spacing={2}>
          <GridHidden item sm={2} only="xs" />
          <Grid item xs={12} sm={8}>
            <Box display="flex" alignItems="baseline">
              <Box mr={2}>
                <Typography variant="body1">Von</Typography>
              </Box>
              <DatePicker
                className={classes.picker}
                disableToolbar
                clearable
                variant="inline"
                format="LL"
                margin="normal"
                id="date-picker-inline-from"
                label=""
                value={timeFilterFrom}
                onChange={onChangeFrom}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
              <Box mr={2} ml={2}>
                <Typography variant="body1">bis</Typography>
              </Box>
              <DatePicker
                className={classes.picker}
                disableToolbar
                clearable
                variant="inline"
                format="LL"
                margin="normal"
                id="date-picker-inline-to"
                label=""
                value={timeFilterTo}
                onChange={onChangeTo}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
              {hasValue && (
                <Box mr={2} ml={2}>
                  <IconButton size="small" onClick={onReset}>
                    <CloseIcon size={20} />
                  </IconButton>
                </Box>
              )}
            </Box>
          </Grid>
          <GridHidden item sm={2} only="xs" />
        </Grid>
      </MuiPickersUtilsProvider>
    </Box>
  );
};

export default TimeFilter;
